import gql from 'graphql-tag';
const START_CAMPAIGN_ORDER_OBSERVATIONS = gql`
  mutation launchObservationJob($id: ID!) {
    launchObservationJob(id: $id)
  }
`;

export default START_CAMPAIGN_ORDER_OBSERVATIONS;
